import React from 'react';
import HomeSection1 from './HomeSection';

const Home = () => {
  return (
    <div>
      <HomeSection1 />
      
    </div>
  );
};

export default Home;
